import script from "./CustomSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomSearch.vue?vue&type=script&lang=ts&setup=true"

import "./CustomSearch.vue?vue&type=style&index=0&id=e1c93a0e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1c93a0e"]])

export default __exports__